<div>
    <app-node-reg-form></app-node-reg-form>
</div>
<!-- <div>
    <app-node-reg-list></app-node-reg-list>
</div> -->